import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Tabs, LargeText } from '@studiometa/ui';
import ConditionalScrollAnimationParent from './ConditionalScrollAnimationParent.js';
import Slider from './Slider/index.js';
import Instagram from './Instagram/index.js';
import ProductLastViewed from './ProductLastViewed.js';
import Tooltips from './Tooltips.js';
import HeroSlider from './HeroSlider.js';
import StyledModal from './StyledModal.js';
import LightboxModal from './LightboxModal.js';
import Cursor from './Cursor.js';

/**
 * Sections component
 */
export default class Sections extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Sections',
    components: {
      Action,
      StyledModal,
      LightboxModal,
      ScrollAnimationParent: ConditionalScrollAnimationParent,
      Tabs,
      LargeText,
      Cursor,
      Slider,
      Instagram,
      ProductLastViewed,
      Tooltips,
      HeroSlider,
      VideoLinks: (app) => importWhenVisible(() => import('./VideoLinks.js'), 'VideoLinks', app),
      Stories: (app) => importWhenVisible(() => import('./Stories/index.js'), 'Stories', app),
      CollectionLinks: (app) =>
        importWhenVisible(() => import('./CollectionLinks.js'), 'CollectionLinks', app),
      ProductRecommendations: (app) =>
        importWhenVisible(
          () => import('./ProductRecommendations.js'),
          'ProductRecommendations',
          app,
        ),
      Video: (app) => importWhenVisible(() => import('./Video.js'), 'Video', app),
      StoreLocator: (app) =>
        importWhenVisible(() => import('./StoreLocator/index.js'), 'StoreLocator', app),
      Accordion: (app) => importWhenVisible(() => import('./Accordion/index.js'), 'Accordion', app),
    },
  };
}
